/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import Link from 'next/link';

import { Button } from '../Button';

const itemMinWidth = css`
	min-width: 172px;
	max-width: 200px;
`;

const IntentModalItem = ({ heading, icon, content, link, closer }) => {
	const innerContent = (
		<div>
			<img
				src={icon}
				height="50"
				width="50"
				className="inline-block"
				alt={heading}
			/>
			<h4 className="text-base font-bold my-2 whitespace-normal">
				{heading}
			</h4>
			<p className="u-para--readable text-lightGray text-sm whitespace-normal mt-0 mx-auto">
				{content}
			</p>
		</div>
	);

	if (link) {
		switch (link.type) {
			case 0:
				return (
					<li
						css={itemMinWidth}
						className="scroll-snap-align-center flex justify-center px-4"
					>
						<Link href={link.url}>
							<a
								onClick={closer}
								className="max-w-lg w-full bg-white shadow-md hover:shadow-lg active:bg-gray-100 active:shadow-inner rounded-lg border px-4 border-gray-400 py-8 my-4 text-center select-none flex flex-col items-center justify-between no-underline"
							>
								{innerContent}
								<Button
									variant="minimal"
									size="tiny"
									className="mt-4"
								>
									{link.text}
								</Button>
							</a>
						</Link>
					</li>
				);
			default:
				return (
					<li
						css={itemMinWidth}
						className="scroll-snap-align-center flex justify-center px-4"
					>
						<a
							href={link.url}
							onClick={closer}
							target="_blank"
							rel="noreferrer noopener nofollow"
							className="max-w-lg w-full bg-white shadow-md hover:shadow-lg active:bg-gray-100 active:shadow-inset rounded-lg border px-4 border-gray-400 py-8 my-4 text-center select-none flex flex-col items-center justify-between no-underline"
						>
							{innerContent}
							<Button
								variant="minimal"
								size="tiny"
								className="mt-4"
							>
								{link.text}
							</Button>
						</a>
					</li>
				);
		}
	}

	return (
		<li
			css={itemMinWidth}
			className="scroll-snap-align-center flex justify-center px-4"
		>
			<div className="w-full bg-white shadow-md border rounded-lg px-4 border-gray-400 py-8 my-4 text-center select-none flex flex-col items-center justify-between">
				{innerContent}
			</div>
		</li>
	);
};

export default IntentModalItem;
